import { AfterViewInit, Directive, ElementRef, inject, input, OnDestroy, Renderer2 } from '@angular/core';
import { forEach, isNil } from 'lodash';

@Directive({
  selector: '[appAddAttributes]',
  standalone: true
})
export class AddAttributes implements AfterViewInit, OnDestroy {
  readonly #elementRef = inject(ElementRef);
  readonly #renderer = inject(Renderer2);

  addAttributes = input.required<{ [elementSelector: string]: { [attributeName: string]: any } }>({});

  #mutationObserver: MutationObserver;

  ngAfterViewInit(): void {
    const element = this.#elementRef?.nativeElement as HTMLElement;

    this.addAttributesToElement(element);

    this.#mutationObserver = new MutationObserver(() => this.addAttributesToElement(element));
    this.#mutationObserver.observe(element, { attributes: true, subtree: false });
  }

  ngOnDestroy(): void {
    this.#mutationObserver?.disconnect();
  }

  private addAttributesToElement(element: HTMLElement) {
    forEach(this.addAttributes(), (attributes, elementSelector) => {
      const innerElements = element?.querySelectorAll(elementSelector);

      forEach(innerElements, (innerElement) => {
        if (!isNil(innerElement)) {
          forEach(attributes, (attributeValue, attributeName) => {
            if (!isNil(attributeValue)) {
              this.#renderer.setAttribute(innerElement, attributeName, attributeValue);
            } else {
              this.#renderer.removeAttribute(innerElement, attributeName);
            }
          });
        }
      });
    });
  }
}
